export enum ExecutionMetricOperation {
  PayonOrderCreateSyncRequisites = 'payin_order_create_sync_requisite',
  PayinOrderCreate = 'payin_order_create',
  PayoutOrderCreate = 'payout_order_create',
}
